import { LOCALES } from '../LOCALES';

const enUs = {
    [LOCALES.ENGLISH]: {
        AI_EDU_AI_ASSISTANT_ADMIN_PORTAL: 'Samsung AI Assistant',
        AI_EDU_CREATE_ORG: 'Create Organization',
        AI_EDU_ADD_ORG_DETAILS:
            'Add organization detail to create new organization',
        AI_EDU_EMAIL_ADDRESS: 'Email Address',
        AI_EDU_EMAIL_CANNOT_BE_CHANGED: 'Email cannot be changed',
        AI_EDU_ORG_NAME: 'Organization Name',
        AI_EDU_ORG_ADDRESS: 'Organization Address',
        AI_EDU_ADDRESS: 'Address',
        AI_EDU_CITY: 'City',
        AI_EDU_COUNTRY: 'Country',
        AI_EDU_STATE_PROVINCE: 'State/ Province',
        AI_EDU_ZIP_CODE: 'ZIP/ postal Code',
        AI_EDU_ORG_ADDED_TITLE: 'Organization is added successfully',
        AI_EDU_ORG_ADDED_SUBTITLE: 'Start adding, managing user and devices',
        AI_EDU_VIEW_DASHBOARD: 'View Dashboard',
        AI_EDU_DASHBOARD: 'Dashboard',
        AI_EDU_USERS: 'Users',
        AI_EDU_DEVICES: 'Devices',
        AI_EDU_ACTIVITY_LOG: 'Activity Log',
        AI_EDU_USER_SESSION: 'User Session',
        AI_EDU_CIRCLE_TO_SEARCH: 'Circle To Search',
        AI_EDU_LIVE_TRANSCRIPT: 'Live Transcript',
        AI_EDU_AI_SUMMARY: 'AI Summary',
        AI_EDU_LOGIN: 'Login',
        AI_EDU_SIGNUP: 'Sign Up',
        AI_EDU_SIGNOUT: 'Sign Out',
        AI_EDU_DELETE: 'Delete',
        AI_EDU_ADMIN: 'Admin',
        AI_EDU_USER: 'User',
        AI_EDU_UPDATE: 'Update',
        AI_EDU_NO_DATA_TO_SHOW: 'No data to show',
        AI_EDU_SEARCH_USER: 'Search User',
        AI_EDU_USER_ID: 'User ID',
        AI_EDU_USER_NAME: 'User Name',
        AI_EDU_EMAIL: 'Email',
        AI_EDU_ACCESS_TYPE: 'Access Type',
        AI_EDU_ACTION: 'Action',
        AI_EDU_SELECT_ACCESS_TYPE: 'Select Access Type',
        AI_EDU_ACCESS_TYPE_SUCCESS: 'User Access Type Updated.',
        AI_EDU_ACCESS_TYPE_FAILURE: 'Error in updating User Access Type.',
        AI_EDU_USER_APPROVED_SUCCESS: 'User Approved.',
        AI_EDU_USER_REJECTED_SUCCESS: 'User Rejected.',
        AI_EDU_USER_APPROVED_FAILURE: 'Error in Approving user.',
        AI_EDU_USER_REJECTED_FAILURE: 'Error in Rejecting user.',
        AI_EDU_DELETE_USERS_TEXT:
            'Are you sure you want to delete the selected users?',
        AI_EDU_DELETE_USER_TEXT:
            'Are you sure you want to delete the selected user?',
        AI_EDU_YES: 'Yes',
        AI_EDU_NO: 'No',
        AI_EDU_CONFIRM: 'Confirm',
        AI_EDU_CLOSE: 'Close',
        AI_EDU_DELETE_ORG_PROMPT:
            'Are you sure ? Removing all admins will permanently delete this organization and all associated data.',
        AI_EDU_DELETE_DEVICES_TEXT:
            'Are you sure you want to delete the selected devices ?',
        AI_EDU_DELETE_DEVICE_TEXT:
            'Are you sure you want to delete the selected device ?',
        AI_EDU_DEVICE_DASHBOARD: 'View Device',
        AI_EDU_USER_DASHBOARD: 'View User',
        AI_EDU_DRAG_N_DROP: 'Drag & drop files here',
        AI_EDU_BROWSE_FILE: 'Browse File',
        AI_EDU_ADD_DEVICES_MANUALLY: 'Manual device addition',
        AI_EDU_ADD_USERS_MANUALLY: 'Manual user addition',
        AI_EDU_UPLOAD_FILE_TO_ADD_USER: 'Upload file to add user',
        AI_EDU_ADD_USER: 'Add User',
        AI_EDU_ADD_DEVICE: 'Add Device',
        AI_EDU_SEARCH_DEVICE_MAC: 'Search Device',
        AI_EDU_DEVICE_MAC: 'Device MAC',
        AI_EDU_DEVICE_NAME: 'Device Name',
        AI_EDU_ADD_MORE: 'Add More',
        AI_EDU_SAVE: 'Save',
        AI_EDU_DUPLICATE_MAC: 'Duplicate MAC address found.',
        AI_EDU_INVALID_MAC_MSG:
            'Please enter valid MAC address for all devices.',
        AI_EDU_DOWNLOAD_FILE_FORMAT: 'Download File format',
        AI_EDU_UPLOAD_FILE: 'Upload File',
        AI_EDU_BULK_USER_ADDITION: 'Bulk user addition',
        AI_EDU_BULK_DEVICE_ADDITION: 'Bulk device addition',
        AI_EDU_ADD_ALL_USERS: 'Add All Users',
        AI_EDU_ADD_ALL_DEVICES: 'Add All Devices',
        AI_EDU_ORG_DETAILS: 'Organization details',
        AI_EDU_ADMIN_SETTINGS: 'Admin settings',
        AI_EDU_LINKED_VIA_MICROSOFT: 'Linked via microsoft account',
        AI_EDU_LINKED_VIA_GOOGLE: 'Linked via google account',
    },
};

export default enUs;
